import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import Edit from "../../components/Config/Edit";
import { useTranslation } from "react-i18next";

const ConfigEditContract = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("config.title"),
					component: (
						<>
							<Edit />
						</>
					),
				}}
				right={null}
			/>
		</>
	);
};

export { ConfigEditContract };
